import { render, staticRenderFns } from "./SpaNav.vue?vue&type=template&id=b2565f18&scoped=true"
import script from "./SpaNav.vue?vue&type=script&lang=js"
export * from "./SpaNav.vue?vue&type=script&lang=js"
import style0 from "./SpaNav.vue?vue&type=style&index=0&id=b2565f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2565f18",
  null
  
)

export default component.exports